import { Avatar } from '@workspace/ui/components/avatar';
import { Users } from 'lucide-react';
import type { Team } from '~/types/team';

interface TeamMentionDropdownProps {
  teams: Team[];
  onSelect: (team: Team) => void;
  selectedIndex: number;
}

export const TeamMentionDropdown = ({
  teams,
  onSelect,
  selectedIndex,
}: TeamMentionDropdownProps) => {
  if (teams.length === 0) {
    return (
      <div className="bg-popover text-popover-foreground border rounded-md shadow-lg p-2 max-h-48 overflow-y-scroll z-[9999] relative scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar scrollbar-thumb-primary-foreground scrollbar-track-background">
        <div className="flex items-center gap-2 px-2 py-1.5 text-sm text-muted-foreground">
          <Users className="h-4 w-4" />
          <span>No se encontraron equipos</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-popover text-popover-foreground border rounded-md shadow-lg p-1 max-h-48 overflow-y-scroll z-[9999] relative flex flex-col-reverse scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar scrollbar-thumb-primary-foreground scrollbar-track-background">
      {teams.map((team, index) => {
        const reversedIndex = teams.length - 1 - index;
        return (
          <button
            key={team.id}
            type="button"
            data-index={reversedIndex}
            className={`flex items-center gap-2 px-2 py-1.5 text-sm cursor-pointer rounded-sm w-full text-left ${
              reversedIndex === selectedIndex
                ? 'bg-accent text-accent-foreground'
                : 'hover:bg-accent hover:text-accent-foreground'
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSelect(team);
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Avatar className="h-6 w-6">
              <div className="flex items-center justify-center w-full h-full bg-blue-500 text-white text-xs font-medium">
                {team.name.charAt(0).toUpperCase()}
              </div>
            </Avatar>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{team.name}</div>
              {team.description && (
                <div className="text-xs text-muted-foreground truncate">
                  {team.description}
                </div>
              )}
            </div>
            <div className="text-xs text-muted-foreground">{team.type}</div>
            <div className="text-xs text-muted-foreground">
              {team.memberCount}{' '}
              {team.memberCount === 1 ? 'miembro' : 'miembros'}
            </div>
          </button>
        );
      })}
    </div>
  );
};
